import "./Header.scss"

import React, { useCallback, useEffect, useState } from "react"
import { FaLock, FaLockOpen } from "react-icons/fa"
import { VscTriangleDown, VscTriangleUp } from "react-icons/vsc"

import { useAccount, useSchedule } from "@shared/contexts"

import classNames from "classnames"
import { useSetRecoilState } from "recoil"
import { BlacklistChattingRole } from "streamerChatting/enums"
import { useBlock } from "streamerChatting/hooks/useBlock"
import { showTermsState } from "streamerChatting/store"
import { store } from "@shared/modules"

interface Props {
  isAllowedBlockChat: boolean | undefined
}

function Header({ isAllowedBlockChat }: Props) {
  const { schedule } = useSchedule()
  const { account } = useAccount()

  const role = account.viewer?.role

  const scheduleIsEmoticon = schedule ? schedule.isEmoticon : true
  const scheduleIsCongratsMessage = schedule ? schedule.isCongratsMessage : true
  const [isChatSetting, setIsChatSetting] = useState<boolean>(false)
  const setShowTerms = useSetRecoilState(showTermsState)
  const {
    isAllBlocking,
    handleToggleBlockingChat,
    handleBlockingAll,
    handleBlockingCongratsMessage,
    handleBlockingEmoticon,
  } = useBlock()

  const isPaidSchedule =
    schedule?.paymentInformation && schedule.paymentInformation === "PAID"

  const handleLockAllClick = () => {
    if (!isAllBlocking) {
      // 잠그는 건 물어볼 필요 없음
      handleToggleBlockingChat(BlacklistChattingRole.ALL)
    } else {
      // 잠금 해제하는건 재차 확인필요
      setShowTerms({
        isOpen: true,
        step: 1,
        isStep1Agreed: false,
        isStep2Agreed: false,
      })
    }
  }

  const handleIsChatSetting = useCallback(() => {
    setIsChatSetting((prev) => !prev)
  }, [])

  useEffect(() => {
    if (!schedule || !schedule?.isChatEnabled || isPaidSchedule) return

    // 부방장 입장 시 잠금이 다시 실행되는 상황을 방지하기 위함
    if (role !== "STREAMER") return

    const initialized = store.session.get("initBlock");
    if (!initialized && !isAllBlocking) handleBlockingAll(schedule)
  }, [schedule, role])

  const showLockButton = !isPaidSchedule && schedule?.isChatEnabled

  return (
    <div className="headB">
      {showLockButton && (
        <div>
          {!isPaidSchedule && (
            <button
              onClick={handleLockAllClick}
              className={classNames(
                {
                  active: isAllBlocking,
                },
                "all",
              )}
            >
              전체
              {isAllBlocking ? (
                <FaLock className="lock" />
              ) : (
                <FaLockOpen className="lock" />
              )}
            </button>
          )}
          <div className={"setting"}>
            <div onClick={handleIsChatSetting}>
              채팅창설정
              {isChatSetting ? <VscTriangleUp /> : <VscTriangleDown />}
            </div>
            {isChatSetting && (
              <>
                <button
                  onClick={(e) => {
                    e.stopPropagation()

                    handleBlockingEmoticon(!scheduleIsEmoticon)
                  }}
                  className={classNames(
                    {
                      active: !scheduleIsEmoticon,
                    },
                    "emoticon",
                  )}
                >
                  이모티콘
                  {!scheduleIsEmoticon ? (
                    <FaLock className="lock" />
                  ) : (
                    <FaLockOpen className="lock" />
                  )}
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation()
                    handleBlockingCongratsMessage(!scheduleIsCongratsMessage)
                  }}
                  className={classNames(
                    {
                      active: !scheduleIsCongratsMessage,
                    },
                    "congrats",
                  )}
                >
                  가입축하
                  {!scheduleIsCongratsMessage ? (
                    <FaLock className="lock" />
                  ) : (
                    <FaLockOpen className="lock" />
                  )}
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default Header
